import { HttpParams } from '@angular/common/http';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ZeitslotBuchung } from '../../../../../projects/kiene-core/src/lib/components/gruppen/schweine/zeitslot-buchen-dialog/zeitslot';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { DialogHtmlComponent } from '../../../../../src/app/components/dialog-html/dialog-html.component';
import { MatDialog } from '@angular/material/dialog';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';

@Component({
    selector: 'kiene-spediteur-anfrage-details',
    templateUrl: './anfrage-details.component.html',
    styleUrls: ['./anfrage-details.component.scss'],
})
export class AnfrageDetailsComponent implements OnInit {
    zeitslot_buchung_id: number;
    zeitslotBuchung: ZeitslotBuchung;
    landwirt: Client;
    schlachthof: Client;
    haendler: Client;
    spediteur: Client;
    selectedIndex = 0;
    lieferscheinNichtAusgefuellt = true;
    lieferschein_id;
    buchung_dateien: Array<any>;
    schlachthofStandort;
    interval;

    pdfBase64: any;

    constructor(
        private api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        private route: ActivatedRoute,
        protected _router: Router,
        private dialog: MatDialog,
        private pdfViewerService: PdfViewerDesktopService,
    ) {
        this.zeitslot_buchung_id = Number(this.route.snapshot.paramMap.get('id'));
    }

    ngOnInit(): void {
        this.ladeZeitslotBuchung();
    }

    tabChanged(event: MatTabChangeEvent) {
        this.selectedIndex = event.index;
    }

    ladeZeitslotBuchung() {
        if (this.zeitslot_buchung_id) {
            const params = new HttpParams().set('zeitslot_buchung_id', this.zeitslot_buchung_id);
            this.api.get(`${this.apiBaseUrl}zeitslot_buchung/read_one.php`, params).subscribe({
                next: (response: any) => {
                    this.zeitslotBuchung = response;
                },
                error: err => {
                    this.messageService.errorMessage('Buchung konnte nicht geladen werden!', err);
                },
            });
        }
    }

    updateBuchung(status: number) {
        this.api
            .post(this.apiBaseUrl + 'zeitslot_buchung/update_buchung.php', this.zeitslotBuchung, undefined)
            .subscribe({
                next: () => {
                    this._router.navigate(['/gruppen', 'schlachtanfragen']).then();
                },
                error: err => {
                    this.messageService.errorMessage('Fehler!', err);
                },
            });
    }

    leseLieferschein() {
        const params = new HttpParams().append('buchungs_id', this.zeitslotBuchung.zeitslot_buchung_id);
        this.api.get(this.apiBaseUrl + 'lieferschein/create_pdf.php', params).subscribe({
            next: response => {
                if (response != null) {
                    this.pdfBase64 = 'data:application/pdf;base64,' + response;

                    const dialogRef = this.dialog.open(DialogHtmlComponent, {
                        data: {
                            headline: 'Lieferschein',
                            okButton: 'PDF Herunterladen',
                            cancelButton: 'Abbrechen',
                            buttonColor: 'accent',
                        },
                    });
                    dialogRef.afterClosed().subscribe({
                        next: result => {
                            if (result?.ok) {
                                this.getPDF(response);
                            }
                        },
                    });
                    let instance = dialogRef.componentInstance;
                    instance.base64 = this.pdfBase64;
                }
            },
            error: error => {
                this.messageService.errorMessage("Fehler beim Ausgeben des PDF's! ", error);
            },
        });
    }

    readSchlachtdaten() {
        const params = new HttpParams().append('zeitslot_buchung_id', this.zeitslotBuchung.zeitslot_buchung_id);
        this.pdfViewerService.openPdfViewer(
            new PdfViewerDialogInput('zeitslot_buchung/get_schlachtdaten.php', params, 'Schlachtdaten'),
        );
    }

    readAbrechnung() {
        const params = new HttpParams().append('zeitslot_buchung_id', this.zeitslotBuchung.zeitslot_buchung_id);
        this.pdfViewerService.openPdfViewer(
            new PdfViewerDialogInput('zeitslot_buchung/get_abrechnung.php', params, 'Abrechnung'),
        );
    }

    getPDF(base64data) {
        var blob = this.b64toBlob(base64data, 'application/pdf');
        let a = document.createElement('a');
        document.body.appendChild(a);
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = String('Lieferschein.pdf');
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    public b64toBlob(b64Data, contentType) {
        contentType = contentType || '';
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    }
}
